import { createTheme, styled } from "@mui/material";
import MuiButton from '@mui/material/Button';

type ButtonProps = {
  rounded?: boolean;
};
const options = {
  shouldForwardProp: (prop) => prop !== 'rounded',
  
};
const Button = styled(
  MuiButton,
  options,
)<ButtonProps>(({ theme, rounded }) => ({
  // borderRadius: rounded ? '24px' : null,
  background:'#2596be',
  fontSize:'14px',
  fontFamily:'Verdana',
  textTransform:'none',
  lineHeight:'1.30em',
  margin:'3px 3px',
  padding:'8px 22px',
  textShadow:'0px opx 8px #2f6627',
  borderWidth:'1px',
  borderColor:'rgba(52, 152,219,1)',
}));

const theme = createTheme({
  shape: {
    borderRadius: 5,
  },
});

export default Button;